import { ECode } from '~/constants';

export default {
    // 成员邀请状态
    MEMBER_INVITE_STATUS: {
        JOINED: 1, // 已加入
        INVITING: 0, // 邀请中
        RESIGNED: -1, // 已离职
        DELETED: -2 // 已彻底删除
    } as const,

    // 企业连接状态
    CORP_CONNECT_STATUS: {
        ACTIVE: 1, // 已连接
        UNJOINED: 0, // 待确认
        INACTIVE: -1 // 已取消关联
    },

    // 最大对接人数量
    MAX_HANDOVER_COUNT_FREE: 20,
    MAX_HANDOVER_COUNT_VIP: 500,

    // 角色类别
    MEMBER_ROLE_TYPE: {
        INTERNAL: 'internal',
        SYNC: 'sync'
    },

    // 根部门id
    DEPARTMENT_ROOT: 1,

    // 离职人员虚拟部门ID
    RESIGNED_ID: -1,

    // 成员同步状态
    MEMBER_ASYNC_STATE: {
        SUCCESS: 0,
        FAILED: 1,
        SYNCING: 2
    },

    // 互联的企业类型
    CORP_COOP_TYPE: {
        HOST: 'host', // 连接我的企业（主体企业）
        GUEST: 'guest' // 我连接的企业（客体企业）
    },

    // 互联的企业menu类型
    CORP_COOP_MENU_TYPE: {
        HOST: 'host', // 连接我的企业（主体企业）
        GUEST: 'guest', // 我连接的企业（客体企业）
        LABEL: 'label' // 标签下的企业
    } as const,

    // 互联组织对接人类型
    CORP_COOP_USER_TYPE: {
        /** 客体对接人，即“全部对接人” */
        GUEST: 'guest',
        /** 主体对接人，即我方对接人 */
        CURRENT: 'current',
        /** 对接人角色 */
        ROLE: 'role'
    } as const,

    // 对接人企业范围
    DOCKER_CORP_RANGE: {
        ALL: 'all', // 全部企业
        SOME: 'some' // 部分企业
    },
    /**
     * 邀请超限错误码
     */
    INVITE_EXCEED_CODE: [
        ECode.CORP_INVITE_MEMBERS_SMS_DAY_LIMIT_EXCEEDED,
        ECode.CORP_INVITE_MEMBERS_EMAIL_DAY_LIMIT_EXCEEDED,
        ECode.CORP_INVITE_MEMBERS_LIMIT_EXCEEDED,
        ECode.CORP_INVITE_MEMBERS_SMS_TOTAL_LIMIT_EXCEEDED,
        ECode.CORP_INVITE_MEMBERS_EMAIL_TOTAL_LIMIT_EXCEEDED,
        ECode.CORP_INVITE_MEMBERS_SMS_AND_EMAIL_TOTAL_LIMIT_EXCEEDED,
        ECode.CORP_INVITE_MEMBERS_SMS_OR_EMAIL_DAY_LIMIT_EXCEEDED,
        ECode.CORP_INVITE_MEMBERS_SMS_OR_EMAIL_TOTAL_LIMIT_EXCEEDED
    ] as const,

    // 互联组织对接人超限错误码（5W）
    HOST_GUEST_DOCKER_EXCEEDED: ECode.CORP_COOP_MEMBER_COUNT_EXCEEDED,
    /**
     * 企业或个人未认证对应的错误码
     * @see FXD-61502
     * @see FXD-61927
     */
    NOT_VERIFIED_CODE: ECode.TENANT_FEATURE_REQUIRES_AUTH_APPROVAL,

    /** 系统/通讯录管理组设置，成员相关错误码 */
    MANAGER_VALID_ERROR: [
        ECode.MANAGE_GROUP_ADD_OWNER,
        ECode.MANAGE_GROUP_COUNT_PER_MEMBER_EXCEEDED,
        ECode.MANAGE_GROUP_REMOVE_SELF,
        ECode.MANAGE_GROUP_SYSTEM_ADMIN_COUNT_LIMIT_EXCEEDED
    ],

    /** 系统管理组id固定为-1 */
    SYSTEM_MANAGER_ID: -1 as const
};
